import { TableRow, TableCell, Skeleton } from '@mui/material'

function TableSkeleton({ rowCount, colCount }) {
  return Array.from({ length: rowCount }, (_, rowIdx) => (
    <TableRow key={`skeleton-row-${rowIdx}`}>
      {Array.from({ length: colCount }, (__, colIdx) => (
        <TableCell key={`skeleton-cell-${rowIdx}-${colIdx}`}>
          <Skeleton variant="text" height={22} />
        </TableCell>
      ))}
    </TableRow>
  ))
}

export default TableSkeleton
